import './ProductReview.style.scss';
import React, { useEffect, useState } from 'react';
import { Tabs, Table, Tag , Button} from 'antd';
import { QuestionCircleFilled } from '@ant-design/icons';
import { getOrders } from '../../../api/productreview';
import { attemptGetOrders } from '../../../store/thunks/orders';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'redux-first-history';
import R from 'ramda';
export default function Orders() {
  
  const dispatch = useDispatch();
  const { user } = useSelector(R.pick(['user']));
  

  
  const [orders, setOrders] = useState();
  const [loading, setLoading] = useState(true);

  // title, price, sku, _quantity, option1, option2, option3 , updated_at 

  const pageSize = 10;  // Set the maximum number of rows per page

  const pagination = {
    pageSize,
  };

  
  const columns = [
    {
      title: 'Brand',
      dataIndex: 'vendor',
      align: 'center',
      className: 'TableCells',
    },
    {
      title: 'Title',
      dataIndex: 'title',
      align: 'center',
      className: 'TableCells',
    },
    {
      title: 'Date',
      dataIndex: 'created_at',
      align: 'center',
      className: 'TableCells',
    },
    {
      dataIndex: 'id',
      align: 'center',
      className: 'TableCells',
      render: (text, record) => (
        <div>
          <Button onClick={()=> window.open('https://admin.shopify.com/store/lokal-eg/products/' + record.id , '_newtab') }>
            {"Admin"}
          </Button>
          {"  "}
          <Button onClick={()=>  window.open('https://lokaleg.com/products/' + record.handle , '_newtab') }>
            {"Listing"}
          </Button>
      
        </div>
        
       ),
    },
    
  ];

  const getData = async () => {
    try {
      setLoading(true); // Set loading to true while fetching data
      const orders = await getOrders();
      console.log('this is list of data we supposedly fetched', orders);
      setOrders(orders);

      

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Set loading to false after fetching data (success or error)
    }
  };

  useEffect(() => {
      if (R.isEmpty(user)) {
      dispatch(push('/login'));
      } else {
        getData();
        console.log('UseEffect Rendered');
      }
  }, []);




    return (
      <div className="OrdersContainer">
        <Table
          columns={columns}
          dataSource={orders}
          scroll={{
            // x: "max-content",
            y: 400,
          }}
          loading={loading}
          size="small"
          tableLayout="auto"
          expandable={true}
          className="OrdersTab"
        />
      </div>
    );
  
}